import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createQuickCheckout } from './quickCheckout.api';

export const useCreateQuickCheckout = ({
  onSuccess,
}: {
  onSuccess?(data: unknown): void;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createQuickCheckout,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
      onSuccess && onSuccess(data);
    },
  });
};
